import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const reasons = [
  {
    title: 'You Work With the Founders',
    desc: 'No unnecessary layers between your business and the people responsible for its success. The planners are the doers.',
    icon: 'FiUsers'
  },
  {
    title: 'Strategy & Execution Combined',
    desc: 'We do not simply tell you what should be done and leave. Our team can plan, design, develop, launch, and optimize.',
    icon: 'FiLayers'
  },
  {
    title: 'Marketing Meets Technology',
    desc: 'LAJ Digital combines marketing experience with hands-on software capabilities. Recommendations are based on what works.',
    icon: 'FiMonitor'
  },
  {
    title: 'Built Around Your Business',
    desc: 'We do not force every client into the same package. We build the right combination of services around your obstacles.',
    icon: 'FiSettings'
  },
  {
    title: 'Clear Communication',
    desc: 'We explain what we are doing and what the results mean. No unnecessary jargon. No hiding behind automated reports.',
    icon: 'FiMessageSquare'
  },
  {
    title: 'Long-Term Accountability',
    desc: 'Your marketing and customer behavior will change. We stay involved and help your systems evolve as a trusted partner.',
    icon: 'FiShield'
  }
];

const WhyUs = () => {
  return (
    <section id="why-us" className="light-section section-padding relative bg-gray-50 border-y border-gray-200/50">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-20 relative z-10">
          <span className="text-cyan-600 font-medium tracking-widest text-sm uppercase mb-4 block font-display">
            Why Businesses Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-gray-900 mb-6">
            Senior Thinking Without the <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">Traditional Layers.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: idx * 0.1 }}
              className="bg-white p-8 rounded-3xl shadow-sm border border-gray-100 group hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-cyan-50 flex items-center justify-center mb-6 text-cyan-600 group-hover:bg-cyan-500 group-hover:text-white transition-colors duration-300">
                <SafeIcon icon={reason.icon} className="text-2xl" />
              </div>
              <h3 className="text-xl font-display font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 font-light leading-relaxed">{reason.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;